<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe max-height="700"
      :show-summary="true" :summary-method="handleSummary">
      <template slot-scope="{ row }" slot="amount">
        <b>
          {{
            formatCurrency(row.amount ? row.amount : 0)
          }}
        </b>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SummaryByGroup',
  props: ['summary'],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('report/serviceOrder', ['resources']),
    columns() {
      return [
        {
          title: this.$t('serviceRequestReport.no'),
          key: 'no',
          width: 60,
          render: (h, params) => {
            return h('span', [params.index + 1])
          },
          align: 'center'
        },
        {
          title: this.$t('serviceRequestReport.fromDate'),
          key: 'from_date',
          minWidth: 200
        },
        {
          title: this.$t('serviceRequestReport.toDate'),
          key: 'to_date',
          minWidth: 200
        },
        {
          title: this.$t('serviceRequestReport.technician1'),
          key: 'technician1_by',
          minWidth: 250
        },
        {
          title: this.$t('serviceRequestReport.total'),
          key: 'technician1_count',
          minWidth: 250,
          align: 'center'
        },
        {
          title: this.$t('serviceRequestReport.amount'),
          slot: 'amount',
          key: 'amount',
          minWidth: 250,
          align: 'right'
        }
      ]
    }
  },
  methods: {
    formatCurrency(amount) {
      return '$' + ' ' + new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      }).format(amount)
    },
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 2) {
          sums[key] = {
            key,
            value: this.$t('serviceRequestReport.total')
          }
          return
        }
        const values = data.map(item => Number(item[key]))
        if (key === 'technician1_by') {
          sums[key] = {
            key,
            value: this.summary.total_technician1_by
          }
        } else if (key === 'technician1_count') {
          sums[key] = {
            key,
            value: this.summary.total_count
          }
        } else if (key === 'amount') {

          const totalAmount = this.formatCurrency(this.summary.total_amount)

          sums[key] = {
            key,
            value: totalAmount
          }
        } else {
          sums[key] = {
            key,
            value: ''
          }
        }
      })

      return sums
    }
  }
}

</script>
<style>
.ivu-table-summary .ivu-table-cell {
  font-weight: bold;
}
</style>